<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="vx-row p-4">
		<div class="vx-col w-full">
			<ul class="ul-area">
				<li class="mt-3">
					<vs-radio v-model="status" vs-value="frequency">{{ $t("TimeWindow.EveryMonth") }}</vs-radio>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="range">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.Every") }} </span>
									<vs-select
										autocomplete
										v-model="numberMonth"
										width="50px"
										class="ml-1"
										:disabled="status !== 'range'"
										:input-changed="getResultMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in numberMonthList"
										/>
									</vs-select>
									<span class="ml-1">{{
										($t("TimeWindow.MonthsStartingAtMonth") + " ") | lowerCase
									}}</span>
									<vs-select
										autocomplete
										v-model="numberNameMonth"
										width="120px"
										class="ml-1"
										:disabled="status !== 'range'"
										:input-changed="getResultMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in nameMonthList"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="choice">{{ $t("TimeWindow.SpecificMonth") }}</vs-radio>
							<div class="vx-row">
								<div class="vx-col w-full">
									<vs-select
										autocomplete
										multiple
										v-model="selectMonth"
										width="100%"
										:disabled="status !== 'choice'"
										:input-changed="getResultMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.code"
											:text="option.text"
											v-for="(option, index) in nameMonthList"
										/>
									</vs-select>
								</div>
							</div>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="betweenMonth">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.EveryMonthBetween") }} </span>
									<vs-select
										autocomplete
										v-model="numbeRangeInit"
										width="120px"
										class="ml-1"
										:disabled="status !== 'betweenMonth'"
										:input-changed="getResultMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in nameMonthList"
										/>
									</vs-select>
									<span class="ml-1">{{ ($t("TimeWindow.And") + " ") | lowerCase }}</span>
									<vs-select
										autocomplete
										v-model="numbeRangeEnd"
										width="120px"
										class="ml-1"
										:disabled="status !== 'betweenMonth'"
										:input-changed="getResultMonth"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in nameMonthList"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "Monthly",
	data() {
		return {
			status: "frequency",
			numberMonth: 1,
			numberNameMonth: 1,
			numbeRangeInit: 1,
			numbeRangeEnd: 1,
			selectMonth: ["JAN"],
			nameMonthList: [
				{text: this.$t("TimeWindow.NameMonth.January"), value: 1, code: "JAN"},
				{text: this.$t("TimeWindow.NameMonth.February"), value: 2, code: "FEB"},
				{text: this.$t("TimeWindow.NameMonth.March"), value: 3, code: "MAR"},
				{text: this.$t("TimeWindow.NameMonth.April"), value: 4, code: "APR"},
				{text: this.$t("TimeWindow.NameMonth.May"), value: 5, code: "MAY"},
				{text: this.$t("TimeWindow.NameMonth.June"), value: 6, code: "JUN"},
				{text: this.$t("TimeWindow.NameMonth.July"), value: 7, code: "JUL"},
				{text: this.$t("TimeWindow.NameMonth.August"), value: 8, code: "AUG"},
				{text: this.$t("TimeWindow.NameMonth.September"), value: 9, code: "SEP"},
				{text: this.$t("TimeWindow.NameMonth.October"), value: 10, code: "OCT"},
				{text: this.$t("TimeWindow.NameMonth.November"), value: 11, code: "NOV"},
				{text: this.$t("TimeWindow.NameMonth.December"), value: 12, code: "DEC"},
			],
		};
	},
	props: {
		cronExpressionMonth: {
			type: String,
			default: "",
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		getResultMonth() {
			let result = "";
			switch (this.status) {
				case "frequency":
					result = "*";
					break;
				case "range":
					result = `${this.numberNameMonth}/${this.numberMonth}`;
					break;
				case "choice":
					result = `${this.selectMonth.join(",")}`;
					break;
				case "betweenMonth":
					result = `${this.numbeRangeInit}-${this.numbeRangeEnd}`;
					break;
			}
			this.$emit("resultMonthEmit", result);
			return result;
		},
		numberMonthList() {
			let numberMonth = [];
			for (let i = 1; i <= 12; i++) {
				numberMonth.push({text: i, value: i});
			}
			return numberMonth;
		},
	},
	mounted() {
		if (
			this.cronExpressionMonth !== " " &&
			this.cronExpressionMonth !== null &&
			this.cronExpressionMonth !== undefined &&
			this.isEdit
		) {
			if (this.cronExpressionMonth.includes("*")) {
				this.status = "frequency";
			} else if (this.cronExpressionMonth.includes("/")) {
				this.numberNameMonth = this.cronExpressionMonth.split("/")[0];
				this.numberMonth = this.cronExpressionMonth.split("/")[1];
				this.status = "range";
			} else if (this.cronExpressionMonth.includes("-")) {
				this.numbeRangeInit = this.cronExpressionMonth.split("-")[0];
				this.numbeRangeEnd = this.cronExpressionMonth.split("-")[1];
				this.status = "between";
			} else {
				if (this.cronExpressionMonth.includes(",")) {
					this.selectMonth = this.cronExpressionMonth.split(",");
				} else {
					this.selectMonth = [this.cronExpressionMonth];
				}
				this.status = "choice";
			}
		}
	},
};
</script>
<style lang="scss">
.form-inline {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-flow: row wrap;
	flex-flow: row wrap;
	-ms-flex-align: center;
	align-items: center;
}
.specific-check {
	display: flex;
	flex-wrap: wrap;
	padding-left: 20px;
}
.check-week {
	padding: 10px 0px 10px 0px;
}
.vs-radio--input + .vs-radio + .vs-radio--label {
	color: #ababab;
	cursor: pointer;
}
.vs-radio--input:checked + .vs-radio + .vs-radio--label {
	color: #000;
}
</style>
